module.exports = __webpack_public_path__ + "img/icon-1.3c035f9a.svg";